import { render, staticRenderFns } from "./PartCategoryEdit.vue?vue&type=template&id=1a49e2ff"
import script from "./PartCategoryEdit.vue?vue&type=script&lang=ts"
export * from "./PartCategoryEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports